<template>
  <div class="second-nav">
    <img class="banner" :src="topBanner" />
    <div>{{topBanner}}</div>
    <div class="content-width main-box" ref="contentBox">
      <div class="left-menu">
        <div class="menu-title flex">
          <img class="classify-icon" src="~assets/img/common/classifyIcon.png">
          <div class="menuList-name overflowHidden1">{{menuList.name}}</div>
        </div>
        <div class="menu-list">
          <div class="menu-item" v-for="(item,index) in menuList.childlist" @click="changeTab(item)">
            <div class="menu-name" v-if="item.status!='hidden'" :class="{'activeColor':item.id==currentClassify.id}">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="menu-title flex">
          <div class="now-location-name">
            您当前所在的位置：{{menuList.name}} >
            <div class="flex">
              <div @click="detailContent!=''?changeTab(currentClassify):''" :class="{'active-color':detailContent!=''}">{{currentClassify.name}}</div>
              <div class="detailContent-title overflowHidden1" v-if="detailContent && detailInfo.title" > > {{detailInfo.title}}</div>
            </div>
          </div>
        </div>
        <news-list
          v-if="detailContent==''"
          :newsList="newsList"
          :total="total"
          :per_page="per_page"
          :current_page="current_page"
          @getList = "getList"
          @getDetail="getNewsDetail"
        >
        </news-list>
        <div class="news-detail" v-if="detailContent!=''">
          <div class="detail-info-title">{{detailInfo.title}}</div>
          <div class="detail-line"></div>
          <div v-html="detailContent"></div>
          <div class="flexBetween detail-info">
            <div>{{detailInfo.source ? '发布来源：' + detailInfo.source : ''}}</div>
            <div>发布时间：{{detailInfo.createtime | formatDate}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {formatDate} from 'utils/tools'
  import {getListData,getInfoData} from "network/newslist"
  import NewsList from "./childComp/NewsList";
  export default {
    name: "SecondNav",
    components:{
      NewsList
    },
    filters: {
      formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd')
      }
    },

    computed:{
      currentClassify(){
        return this.$store.state.currentClassify
      },
      menuList(){
        return this.$store.getters.getSecondClassify
      },
      topBanner(){
        let postImg = this.$store.getters.getposter
        if(postImg){
          return this.urlConfig + postImg
        }else{
          return 'http://www.hotour.com.cn/b2cFrame/styles/images/jtgk.jpg'
        }
      }
    },
    watch:{
      currentClassify(){
        this.detailContent=''
        if(this.currentClassify.diyname){
          this.getList()
        }
      }
    },
    data(){
      return{
        newsList:[],
        detailContent:'',
        detailInfo:'',
        total:0,
        per_page:0,
        current_page: 1
      }
    },
    mounted() {
      setTimeout(()=>{
        let id = Number(this.$route.query.id)
        if(id){
          this.getNewsDetail(id)
        }else{
          this.getList(1)
        }
      },1000)
    },
    updated() {
      window.scrollTo(0,0)
      const contentY = this.$refs.contentBox.getBoundingClientRect().top - 30
      document.documentElement.scrollTop = contentY
    },
    methods:{
      changeTab(item){
        this.isDetail(item)
      },
      getList(page){
        getListData(
          this.currentClassify.diyname,
          {
            page: page,
            list_rows: 10,
            cate_id: this.currentClassify.id
          }
        ).then((res)=>{
          this.total = Number(res.data.total)
          this.newsList = res.data.data
          this.per_page = Number(res.data.per_page)
          this.current_page = Number(res.data.current_page)
        })
      },
      // 获取详情
      getNewsDetail(id){
        getInfoData(this.currentClassify.diyname,id).then((res)=>{
          this.$router.replace({path:'/secondtheme',query:{cid:this.currentClassify.id,id:id}}) //修改
          let a = res.data.content;
          // a 为富文本的字符串内容，为了测试，只写了img标签
          let b = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;// img 标签取src里面内容的正则
          let s = a.match(b);// 取到所有img标签 放到数组 s里面
          if(s && s.length > 0){
            for (let i = 0; i < s.length; i++) {
              let srcImg = s[i].replace(b, '$1');//取src面的内容
              if (srcImg.slice(0, 4) == 'http' || srcImg.slice(0, 5) == 'https') {
              } else {
                //修改富文本字符串内容 img标签src 相对路径改为绝对路径
                a = a.replace(new RegExp("\"" + srcImg, 'g'), `"${this.apiUrl}${srcImg}`);
              }
            }
          }
          this.detailContent = a
          this.detailInfo = {
            title:res.data.title || '',
            views:res.data.views || '',
            source:res.data.source || '',
            createtime:res.data.createtime || ''
          }
        })
      },
      isDetail(item){
        let isDet = [6,10,11,12,14,15,25].indexOf(item.id)
        if(isDet == -1){
          this.$router.replace({path:'secondtheme',query:{cid:item.id}}) //修改
          if(item.id==this.currentClassify.id){
            this.detailContent=''
            this.getList()
          }else{
            this.$store.commit('changeClassify',item)
          }
        }else{
          this.$store.commit('changeClassify',item)
          this.$router.replace({path:'newsdetail',query:{id:item.id}})
        }
      }
    }
  }
</script>

<style scoped>
  /*/deep/p{*/
  /*  font-size: 17px !important;*/
  /*  line-height: 34px !important;*/
  /*}*/
  /deep/img{
    max-width: 100%;
    height: auto;
  }
  .second-nav{
    margin-bottom: 80px;
  }
  .banner{
    display: block;
    width: 100%;
  }

  .main-box{
    display: flex;
    padding-top: 60px;
    width: 100%;
  }

  .left-menu{
    width: 280px;
    height: fit-content;
    border: 1px solid #e9e9e9;
    overflow: hidden;
    border-radius: 5px;
  }

  .classify-icon{
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .menu-title{
    font-family: SourceMedium;
    height: 50px;
    background: #f9f9f9;
    color: black;
    font-size: 18px;
    padding-left: 20px;
  }

  .menu-list{
    padding: 30px 0;
    min-height: 350px;
  }

  .menu-item{
    font-family: SourceMedium;
    position: relative;
    font-size: 16px;
    color: #333;
    height: 50px;
    line-height: 50px
  }

  .menu-name{
    padding: 0 30px;
  }

  .activeColor{
    background:linear-gradient(90deg,#74ba28,#ffffff);
    color: white;
  }

  .right-content{
    width: calc(100% - 304px);
    text-align: justify;
    margin-left: 30px;
    color: #333;
    border: 1px solid #e9e9e9;
    overflow: hidden;
    border-radius: 5px;
  }

  .news-detail{
    padding: 105px 50px 80px 50px;
  }

  .detail-info{
    font-family: SourceMedium;
    font-size: 18px;
    color: #333;
    margin-top: 400px;
  }

  .detail-info-title{
    font-family: SourceMedium;
    font-size: 30px;
    text-align: center;
    margin-bottom: 40px;
    font-weight: bold;
  }

  .detailContent-title{
    width: 300px;color: #999
  }

  .detail-line{
    height: 1px;
    width: 80px;
    background: #e5e5e5;
    box-shadow: 0 0 3px #e5e5e5;
    margin: 0 auto;
    margin-bottom: 40px;
  }

  .now-location-name{
    display: flex;
    font-family: SourceRegular;
    font-size: 16px;
  }

  .active-color{
    border-bottom: 1px solid black;
  }

  .active-color:hover{
    color: #014099;
    border-bottom: 1px solid #014099;
    font-weight: bold;
  }
</style>
